import { LevelData } from '../level-data';

export const level19: LevelData = {
    name: 'Insanity',
    timeLimit: 120,
    track: [
        '-------',
        '-------',
        '---B---',
        '-------',
        '  ---  ',
        '-------',
        '--   --',
        '-------',
        '---B---',
        '-------',
        '  ---  ',
        '-------',
        '--   --',
        '-------',
        '---S---',
        '-------',
        '  ---  ',
        '-------',
        '--   --',
        '-------',
        '---B---',
        '-------',
        '       ',
        '       ',
        '-------',
        '-------',
        '--   --',
        '-------',
        '---B---',
        '-------',
        '  ---  ',
        '-------',
        '--   --',
        '-------',
        '---B---',
        '-------',
        '  ---  ',
        '-------',
        '--   --',
        '-------',
        '---S---',
        '-------',
        '  ---  ',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        'FFFFFFF',
    ],
};
